// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import BrainBreak from "./brain-break.js"
import Challenge from "./challenge.js"
import CheckIn from "./check-in.js"
import ClassStep from "./class-step.js"
import CourseAudit from "./course-audit.js"
import CourseClassStep from "./course-class-step.js"
import CourseGroup from "./course-group.js"
import CourseGroupCourse from "./course-group-course.js"
import CourseModule from "./course-module.js"
import ScoreFactor from "./score-factor.js"

const modelClassData = {
  "attributes": {
    "background_image_content_type": {
      "column": null,
      "name": "background_image_content_type",
      "selected_by_default": false,
      "translated": false
    },
    "background_image_url": {
      "column": null,
      "name": "background_image_url",
      "selected_by_default": false,
      "translated": false
    },
    "course_modules_count": {
      "column": {
        "default": "0",
        "name": "course_modules_count",
        "null": false,
        "type": "integer"
      },
      "name": "course_modules_count",
      "selected_by_default": null,
      "translated": false
    },
    "course_page_theme": {
      "column": {
        "default": null,
        "name": "course_page_theme",
        "null": true,
        "type": "string"
      },
      "name": "course_page_theme",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "highlighted_in_top": {
      "column": {
        "default": "0",
        "name": "highlighted_in_top",
        "null": false,
        "type": "boolean"
      },
      "name": "highlighted_in_top",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "public": {
      "column": {
        "default": "0",
        "name": "public",
        "null": false,
        "type": "boolean"
      },
      "name": "public",
      "selected_by_default": null,
      "translated": false
    },
    "random_content": {
      "column": {
        "default": "0",
        "name": "random_content",
        "null": false,
        "type": "boolean"
      },
      "name": "random_content",
      "selected_by_default": null,
      "translated": false
    },
    "score_factor_id": {
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": true,
        "type": null
      },
      "name": "score_factor_id",
      "selected_by_default": null,
      "translated": false
    },
    "translated_course_page_theme": {
      "column": null,
      "name": "translated_course_page_theme",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "value_points": {
      "column": {
        "default": null,
        "name": "value_points",
        "null": true,
        "type": "integer"
      },
      "name": "value_points",
      "selected_by_default": null,
      "translated": false
    },
    "description": {
      "column": null,
      "name": "description",
      "selected_by_default": false,
      "translated": true
    },
    "description_da": {
      "column": null,
      "name": "description_da",
      "selected_by_default": false,
      "translated": false
    },
    "description_en": {
      "column": null,
      "name": "description_en",
      "selected_by_default": false,
      "translated": false
    },
    "description_no": {
      "column": null,
      "name": "description_no",
      "selected_by_default": false,
      "translated": false
    },
    "description_se": {
      "column": null,
      "name": "description_se",
      "selected_by_default": false,
      "translated": false
    },
    "estimated_time": {
      "column": null,
      "name": "estimated_time",
      "selected_by_default": false,
      "translated": true
    },
    "estimated_time_da": {
      "column": null,
      "name": "estimated_time_da",
      "selected_by_default": false,
      "translated": false
    },
    "estimated_time_en": {
      "column": null,
      "name": "estimated_time_en",
      "selected_by_default": false,
      "translated": false
    },
    "estimated_time_no": {
      "column": null,
      "name": "estimated_time_no",
      "selected_by_default": false,
      "translated": false
    },
    "estimated_time_se": {
      "column": null,
      "name": "estimated_time_se",
      "selected_by_default": false,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "Course",
  "collectionKey": "courses",
  "collectionName": "courses",
  "i18nKey": "course",
  "camelizedLower": "course",
  "name": "Course",
  "nameDasherized": "course",
  "pluralName": "courses",
  "ransackable_associations": [
    {
      "className": "Course::Audit",
      "collectionName": "course_audits",
      "foreignKey": "course_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "CourseAudit",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": null,
      "foreignKey": "record_id",
      "name": "background_image_attachment",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": null,
      "foreignKey": "blob_id",
      "name": "background_image_blob",
      "macro": "has_one",
      "resource_name": null,
      "through": "background_image_attachment"
    },
    {
      "className": "BrainBreak",
      "collectionName": "brain_breaks",
      "foreignKey": "course_id",
      "name": "brain_break",
      "macro": "has_one",
      "resource_name": "BrainBreak",
      "through": null
    },
    {
      "className": "Challenge",
      "collectionName": "challenges",
      "foreignKey": "course_id",
      "name": "challenge",
      "macro": "has_one",
      "resource_name": "Challenge",
      "through": null
    },
    {
      "className": "CheckIn",
      "collectionName": "check_ins",
      "foreignKey": "course_id",
      "name": "check_in",
      "macro": "has_one",
      "resource_name": "CheckIn",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "course_class_steps"
    },
    {
      "className": "CourseClassStep",
      "collectionName": "course_class_steps",
      "foreignKey": "course_id",
      "name": "course_class_steps",
      "macro": "has_many",
      "resource_name": "CourseClassStep",
      "through": null
    },
    {
      "className": "CourseGroupCourse",
      "collectionName": "course_group_courses",
      "foreignKey": "course_id",
      "name": "course_group_courses",
      "macro": "has_many",
      "resource_name": "CourseGroupCourse",
      "through": null
    },
    {
      "className": "CourseGroup",
      "collectionName": "course_groups",
      "foreignKey": "course_group_id",
      "name": "course_groups",
      "macro": "has_many",
      "resource_name": "CourseGroup",
      "through": "course_group_courses"
    },
    {
      "className": "CourseModule",
      "collectionName": "course_modules",
      "foreignKey": "course_id",
      "name": "course_modules",
      "macro": "has_many",
      "resource_name": "CourseModule",
      "through": null
    },
    {
      "className": "Course::Audit",
      "collectionName": "course_audits",
      "foreignKey": "course_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CourseAudit",
      "through": null
    },
    {
      "className": "Course::Translation",
      "collectionName": null,
      "foreignKey": "course_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SchoolClassCourse",
      "collectionName": "school_class_courses",
      "foreignKey": "course_id",
      "name": "school_class_courses",
      "macro": "has_many",
      "resource_name": "SchoolClassCourse",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "Course::Translation",
      "collectionName": null,
      "foreignKey": "course_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "CourseModule",
      "collectionName": "course_modules",
      "foreignKey": "course_id",
      "name": "visible_course_modules",
      "macro": "has_many",
      "resource_name": "CourseModule",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_class_steps_count",
      "column": {
        "default": "0",
        "name": "course_class_steps_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "course_modules_count",
      "column": {
        "default": "0",
        "name": "course_modules_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "course_page_theme",
      "column": {
        "default": null,
        "name": "course_page_theme",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "highlighted_in_top",
      "column": {
        "default": "0",
        "name": "highlighted_in_top",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "public",
      "column": {
        "default": "0",
        "name": "public",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "random_content",
      "column": {
        "default": "0",
        "name": "random_content",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "score_factor_id",
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "value_points",
      "column": {
        "default": null,
        "name": "value_points",
        "null": true,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "for_school_class"
    },
    {
      "name": "not_taken_by_school_classes"
    }
  ],
  "relationships": [
    {
      "className": "BrainBreak",
      "collectionName": "brain_breaks",
      "foreignKey": "course_id",
      "name": "brain_break",
      "macro": "has_one",
      "resource_name": "BrainBreak",
      "through": null
    },
    {
      "className": "Challenge",
      "collectionName": "challenges",
      "foreignKey": "course_id",
      "name": "challenge",
      "macro": "has_one",
      "resource_name": "Challenge",
      "through": null
    },
    {
      "className": "CheckIn",
      "collectionName": "check_ins",
      "foreignKey": "course_id",
      "name": "check_in",
      "macro": "has_one",
      "resource_name": "CheckIn",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "course_class_steps"
    },
    {
      "className": "CourseClassStep",
      "collectionName": "course_class_steps",
      "foreignKey": "course_id",
      "name": "course_class_steps",
      "macro": "has_many",
      "resource_name": "CourseClassStep",
      "through": null
    },
    {
      "className": "CourseGroup",
      "collectionName": "course_groups",
      "foreignKey": "course_group_id",
      "name": "course_groups",
      "macro": "has_many",
      "resource_name": "CourseGroup",
      "through": "course_group_courses"
    },
    {
      "className": "CourseGroupCourse",
      "collectionName": "course_group_courses",
      "foreignKey": "course_id",
      "name": "course_group_courses",
      "macro": "has_many",
      "resource_name": "CourseGroupCourse",
      "through": null
    },
    {
      "className": "CourseModule",
      "collectionName": "course_modules",
      "foreignKey": "course_id",
      "name": "course_modules",
      "macro": "has_many",
      "resource_name": "CourseModule",
      "through": null
    },
    {
      "className": "Course::Audit",
      "collectionName": "course_audits",
      "foreignKey": "course_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CourseAudit",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "CourseModule",
      "collectionName": "course_modules",
      "foreignKey": "course_id",
      "name": "visible_course_modules",
      "macro": "has_many",
      "resource_name": "CourseModule",
      "through": null
    }
  ],
  "paramKey": "course",
  "primaryKey": "id"
}

/** Frontend model for Course. */
export default class Course extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  backgroundImageContentType() {
    return this.readAttributeUnderscore("background_image_content_type")
  }

  /** @returns {boolean} */
  hasBackgroundImageContentType() {
    const value = this.backgroundImageContentType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  backgroundImageUrl() {
    return this.readAttributeUnderscore("background_image_url")
  }

  /** @returns {boolean} */
  hasBackgroundImageUrl() {
    const value = this.backgroundImageUrl()

    return this._isPresent(value)
  }

  /** @returns {number} */
  courseModulesCount() {
    return this.readAttributeUnderscore("course_modules_count")
  }

  /** @returns {boolean} */
  hasCourseModulesCount() {
    const value = this.courseModulesCount()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  coursePageTheme() {
    return this.readAttributeUnderscore("course_page_theme")
  }

  /** @returns {boolean} */
  hasCoursePageTheme() {
    const value = this.coursePageTheme()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  highlightedInTop() {
    return this.readAttributeUnderscore("highlighted_in_top")
  }

  /** @returns {boolean} */
  hasHighlightedInTop() {
    const value = this.highlightedInTop()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  public() {
    return this.readAttributeUnderscore("public")
  }

  /** @returns {boolean} */
  hasPublic() {
    const value = this.public()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  randomContent() {
    return this.readAttributeUnderscore("random_content")
  }

  /** @returns {boolean} */
  hasRandomContent() {
    const value = this.randomContent()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  scoreFactorId() {
    return this.readAttributeUnderscore("score_factor_id")
  }

  /** @returns {boolean} */
  hasScoreFactorId() {
    const value = this.scoreFactorId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedCoursePageTheme() {
    return this.readAttributeUnderscore("translated_course_page_theme")
  }

  /** @returns {boolean} */
  hasTranslatedCoursePageTheme() {
    const value = this.translatedCoursePageTheme()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  valuePoints() {
    return this.readAttributeUnderscore("value_points")
  }

  /** @returns {boolean} */
  hasValuePoints() {
    const value = this.valuePoints()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionDa() {
    return this.readAttributeUnderscore("description_da")
  }

  /** @returns {boolean} */
  hasDescriptionDa() {
    const value = this.descriptionDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionEn() {
    return this.readAttributeUnderscore("description_en")
  }

  /** @returns {boolean} */
  hasDescriptionEn() {
    const value = this.descriptionEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionNo() {
    return this.readAttributeUnderscore("description_no")
  }

  /** @returns {boolean} */
  hasDescriptionNo() {
    const value = this.descriptionNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  descriptionSe() {
    return this.readAttributeUnderscore("description_se")
  }

  /** @returns {boolean} */
  hasDescriptionSe() {
    const value = this.descriptionSe()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  estimatedTime() {
    return this.readAttributeUnderscore("estimated_time")
  }

  /** @returns {boolean} */
  hasEstimatedTime() {
    const value = this.estimatedTime()

    return this._isPresent(value)
  }

  /** @returns {any} */
  estimatedTimeDa() {
    return this.readAttributeUnderscore("estimated_time_da")
  }

  /** @returns {boolean} */
  hasEstimatedTimeDa() {
    const value = this.estimatedTimeDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  estimatedTimeEn() {
    return this.readAttributeUnderscore("estimated_time_en")
  }

  /** @returns {boolean} */
  hasEstimatedTimeEn() {
    const value = this.estimatedTimeEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  estimatedTimeNo() {
    return this.readAttributeUnderscore("estimated_time_no")
  }

  /** @returns {boolean} */
  hasEstimatedTimeNo() {
    const value = this.estimatedTimeNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  estimatedTimeSe() {
    return this.readAttributeUnderscore("estimated_time_se")
  }

  /** @returns {boolean} */
  hasEstimatedTimeSe() {
    const value = this.estimatedTimeSe()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  take(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "take",
        primaryKey: this.primaryKey(),
        collectionName: "courses",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  takeOrContinue(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "take_or_continue",
        primaryKey: this.primaryKey(),
        collectionName: "courses",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./brain-break.js").default | null} */
  brainBreak() {
    return this._readHasOneReflection({modelClass: BrainBreak, reflectionName: "brain_break"})
  }

  /** @returns {Promise<import("./brain-break.js").default | null>} */
  loadBrainBreak() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["course_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "brain_break",
        model: this,
        modelClass: BrainBreak
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./brain-break.js").default | null>} */
  ensureBrainBreakLoaded() {
    return this.ensureAssociationLoaded("brain_break")
  }

  /** @returns {import("./challenge.js").default | null} */
  challenge() {
    return this._readHasOneReflection({modelClass: Challenge, reflectionName: "challenge"})
  }

  /** @returns {Promise<import("./challenge.js").default | null>} */
  loadChallenge() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["course_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "challenge",
        model: this,
        modelClass: Challenge
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./challenge.js").default | null>} */
  ensureChallengeLoaded() {
    return this.ensureAssociationLoaded("challenge")
  }

  /** @returns {import("./check-in.js").default | null} */
  checkIn() {
    return this._readHasOneReflection({modelClass: CheckIn, reflectionName: "check_in"})
  }

  /** @returns {Promise<import("./check-in.js").default | null>} */
  loadCheckIn() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["course_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "check_in",
        model: this,
        modelClass: CheckIn
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./check-in.js").default | null>} */
  ensureCheckInLoaded() {
    return this.ensureAssociationLoaded("check_in")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./class-step.js").default>} */
  classSteps() {
    return new Collection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "Course",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  loadClassSteps() {
    return this._loadHasManyReflection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "Course",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  ensureClassStepsLoaded() {
    return this.ensureAssociationLoaded("class_steps")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-class-step.js").default>} */
  courseClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_class_steps",
        model: this,
        modelClass: CourseClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-class-step.js").default>>} */
  loadCourseClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_class_steps",
        model: this,
        modelClass: CourseClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-class-step.js").default>>} */
  ensureCourseClassStepsLoaded() {
    return this.ensureAssociationLoaded("course_class_steps")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-group.js").default>} */
  courseGroups() {
    return new Collection(
      {
        reflectionName: "course_groups",
        model: this,
        modelClass: CourseGroup
      },
      {
        params: {
          through: {
            model: "Course",
            id: this.primaryKey(),
            reflection: "course_groups"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./course-group.js").default>>} */
  loadCourseGroups() {
    return this._loadHasManyReflection(
      {
        reflectionName: "course_groups",
        model: this,
        modelClass: CourseGroup
      },
      {
        params: {
          through: {
            model: "Course",
            id: this.primaryKey(),
            reflection: "course_groups"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./course-group.js").default>>} */
  ensureCourseGroupsLoaded() {
    return this.ensureAssociationLoaded("course_groups")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-group-course.js").default>} */
  courseGroupCourses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_group_courses",
        model: this,
        modelClass: CourseGroupCourse
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-group-course.js").default>>} */
  loadCourseGroupCourses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_group_courses",
        model: this,
        modelClass: CourseGroupCourse
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-group-course.js").default>>} */
  ensureCourseGroupCoursesLoaded() {
    return this.ensureAssociationLoaded("course_group_courses")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-module.js").default>} */
  courseModules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "course_modules",
        model: this,
        modelClass: CourseModule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-module.js").default>>} */
  loadCourseModules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "course_modules",
        model: this,
        modelClass: CourseModule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-module.js").default>>} */
  ensureCourseModulesLoaded() {
    return this.ensureAssociationLoaded("course_modules")
  }

  /** @returns {import("./course-audit.js").default | null} */
  createAudit() {
    return this._readHasOneReflection({modelClass: CourseAudit, reflectionName: "create_audit"})
  }

  /** @returns {Promise<import("./course-audit.js").default | null>} */
  loadCreateAudit() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["course_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "create_audit",
        model: this,
        modelClass: CourseAudit
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./course-audit.js").default | null>} */
  ensureCreateAuditLoaded() {
    return this.ensureAssociationLoaded("create_audit")
  }

  /** @returns {import("./score-factor.js").default | null} */
  scoreFactor() {
    return this._readBelongsToReflection({modelClass: ScoreFactor, reflectionName: "score_factor"})
  }

  /** @returns {Promise<import("./score-factor.js").default | null>} */
  loadScoreFactor() {
    if (!("scoreFactorId" in this)) throw new Error("Foreign key method wasn't defined: scoreFactorId")

    const id = this.scoreFactorId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "score_factor",
        model: this,
        modelClass: ScoreFactor
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./score-factor.js").default | null>} */
  ensureScoreFactorLoaded() {
    return this.ensureAssociationLoaded("score_factor")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./course-module.js").default>} */
  visibleCourseModules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "visible_course_modules",
        model: this,
        modelClass: CourseModule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-module.js").default>>} */
  loadVisibleCourseModules() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["course_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "visible_course_modules",
        model: this,
        modelClass: CourseModule
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./course-module.js").default>>} */
  ensureVisibleCourseModulesLoaded() {
    return this.ensureAssociationLoaded("visible_course_modules")
  }
}
